import  { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import { resetMessage } from "../../../../store/slices/Notification";

const useCustomSnackBar = () => {
  const notification = useSelector((data: RootState) => data.notification);
  const dispatch = useDispatch();
  useEffect(() => {
    if (notification.isOpen) {
      setTimeout(() => {
        if (notification?.isOpen) {
          dispatch(resetMessage());
        }
      }, notification.duration);
    }
  }, [dispatch, notification]);
  return { notification, dispatch };
};

export default useCustomSnackBar;
